import styled from 'styled-components';
import Button from 'components/ui-components/Button';

const ApprovalsGroupUser = ({
  title,
  user,
  openUserMessageModal,
  isAdmin,
  usersLength,
  userCount,
}) => {
  const {
    forename,
    surname,
    email,
    credit_limit: creditLimit,
    max_approval_limit: maxApprovalLimit,
  } = user;

  const hideRemoveButton =
    (usersLength === 1 && isAdmin) || (userCount === 1 && isAdmin);
  const limitTypes = {
    'Group Administrators': 'No Limit',
    Approvers: `£${maxApprovalLimit}`,
    'Standard Users': `£${creditLimit}`,
  };
  const limitType = limitTypes[title];

  return (
    <li className="create-group-user fl jc-sb ptb-12 pl-12 pr-14">
      <div>
        <h4
          data-testid="user-name"
          className="ff-body fw-600 fs-14 tc-grey-70 lh-1-1 mb-0">
          {`${forename} ${surname}`}
        </h4>
        <p className="ff-body fs-14 tc-grey-50 lh-1-1 mb-0">{email}</p>
      </div>
      <div className="create-group-user__wrapper fl jc-sb">
        <p className="ff-body fw-600 fs-14 tc-grey-70 lh-1 mb-0 js-fe mr-90">
          {limitType}
        </p>

        {!hideRemoveButton && (
          <RemoveBtn
            handleClick={() => openUserMessageModal(user, title)}
            className="bg-transparent tc-cef-red as-c fw-500 p-0">
            Remove
          </RemoveBtn>
        )}
      </div>
    </li>
  );
};

const RemoveBtn = styled(Button)`
  min-height: 0;
`;

export default ApprovalsGroupUser;
